export enum MenuActions {
  VISUALIZZA_FASCICOLO,
  INSERISCI_FASCICOLO,
  CREA_FASCICOLO,
  VISUALIZZA_PRATICA,
  CREA_PRATICA,
  INSERISCI_FASCICOLO_E_VEDI_PRATICA
}
